import * as yup from 'yup';

import { validateDate, validateEmail } from 'app/utils/validations';

const personFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is mandatory')
    .min(2, 'First name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "First name should only contain letters, spaces, and symbols (.-')"
    ),
  lastName: yup
    .string()
    .required('Last name is mandatory')
    .min(2, 'Last name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "Last name should only contain letters, spaces, and symbols (.-')"
    ),
  email: yup
    .string()
    .required('Company email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
  startDate: yup
    .string()
    .test('Invalid date', 'Enter a valid date', (value) => !value || validateDate(value)),
  phoneNumber: yup.string(),
  canTopUpCompanyPoints: yup.boolean(),
  externalPayrollId: yup.string(),
  payCalendarId: yup.string(),
  salaried: yup.boolean(),
});

export const personFormSchemaDefault = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is mandatory')
    .min(2, 'First name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "First name should only contain letters, spaces, and symbols (.-')"
    ),
  lastName: yup
    .string()
    .required('Last name is mandatory')
    .min(2, 'Last name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "Last name should only contain letters, spaces, and symbols (.-')"
    ),
  email: yup
    .string()
    .required('Company email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
  startDate: yup
    .string()
    .required('Start date is mandatory')
    .test('Invalid date', 'Enter a valid date', (value) => !value || validateDate(value)),
  phoneNumber: yup.string(),
  canTopUpCompanyPoints: yup.boolean(),
  externalPayrollId: yup.string().required('Payroll ID is mandatory'),
  payCalendarId: yup.string().required('Pay calendar is mandatory'),
  salaried: yup.boolean().required('Please select salaried or non-salaried'),
});

export default personFormSchema;
